import { useEffect, useState } from 'react';
import { WheelsTimeFilters } from '../../../domain/wheels';
import { useStatus } from '../../../hooks';
import { getWheelsTimeFiltersFromLocalStorage } from '../utils';

export const useWheelsTimeFilters = () => {
  const [timeFilters, setTimeFilters] = useState<WheelsTimeFilters | null>(null);
  const { isIdle, isDone, isLoading, setStatusLoading, setStatusDone, setStatusError } = useStatus();

  const getParkingFilters = async () => {
    setStatusLoading();

    const filters = getWheelsTimeFiltersFromLocalStorage();
    setTimeFilters(filters);

    setStatusDone();
  };

  useEffect(() => {
    getParkingFilters();
  }, []);

  return { timeFilters, isIdle, isLoading, isDone };
};
